import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { REFETCH_APP_DATA_ACTIONS } from 'containers/App/constants'
import { UPDATE_USER_REQUEST_ASYNC } from 'containers/Settings/Users/constants'

import { selectCompaniesData, selectPartner, selectSelfCompanyId } from '../App/selectors'

import { fetchSelectedCompanyDataError, fetchSelectedCompanyDataSuccess } from './actions'
import { COMPANY_FILTER_APPLY, COMPANY_FILTER_CHANGE } from './constants'
import { selectCompanyFilter } from './selectors'

const fetchSelectedCompanyDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(COMPANY_FILTER_CHANGE, UPDATE_USER_REQUEST_ASYNC.SUCCESS, ...REFETCH_APP_DATA_ACTIONS)
    .filter(() => !!selectPartner(store.getState()))
    .mergeMap((action) => {
      const state = store.getState()

      const selfCompanyId = selectSelfCompanyId(state)
      const selectedCompanyId = selectCompanyFilter(state)?.value
      const isDataExist = selectCompaniesData(state).find((c) => c.id === selectedCompanyId)

      if (
        action.type === COMPANY_FILTER_CHANGE &&
        (selfCompanyId === selectedCompanyId || isDataExist)
      ) {
        return Observable.of(fetchSelectedCompanyDataSuccess(null))
      } else {
        return api.msp
          .getCompanyData(selectedCompanyId)
          .map((response) => fetchSelectedCompanyDataSuccess(response))
          .catch((error) => Observable.of(epicsErrorHandler(fetchSelectedCompanyDataError, error)))
      }
    })

const changeSelectedCompanyEpic = (action$) =>
  action$.ofType(COMPANY_FILTER_APPLY, COMPANY_FILTER_CHANGE).mergeMap((action) => {
    if (typeof window.dataLayer?.push === 'function') {
      // Google Tag Manager
      window.dataLayer.push({
        selectedCompanyId: action.payload.selectedCompany.value,
      })
    }
    return Observable.of(() => {})
  })

export default combineEpics(fetchSelectedCompanyDataEpic, changeSelectedCompanyEpic)
